<template>
  <nav
    class="navbar is-dark is-fixed-top"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="container">
      <router-link to="/">
        <img
          src="/static/emprego_logo.png"
          class="main-logo"
          alt="aeISEP Logo"
        />
      </router-link>
      <a href="https://aeisep.pt" target="_blank" class="aeisep_a">
        <img class="aeisep-logo" src="/static/aeisep.png" alt="aeISEP Logo" />
      </a>
    </div>
  </nav>
</template>

<script>
export default {
  name: "the-header",
  watch: {
    $route() {
      this.showNav = false;
    },
  },
  data() {
    return {
      showNav: false,
    };
  },
};
</script>

<style scoped>
.main-logo {
  width: 200px;
  margin: 5px 5px;
}
.aeisep-logo {
  height: 70px;
  position: absolute;
  right: 10px;
}
.aeisep_a {
  align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/components/TheHeader.vue